/* LLCL Atelier Trust V2: open original trust drawer and nested contact disclosure */
(()=>{'use strict';if(window.__llAtelierTrustV2)return;window.__llAtelierTrustV2=true;
const panel=()=>document.querySelector('details[data-ll-atelier-details]');
function open(focus){const node=panel();if(!node)return;const trust=node.closest('[data-ll-trust]');const manager=window.LLInternationalTrustManager||window.LLInternationalTrust;if(typeof manager?.open==='function')manager.open();else if(trust&&!trust.classList.contains('is-expanded'))trust.querySelector('[data-ll-trust-toggle]')?.click();node.open=true;requestAnimationFrame(()=>setTimeout(()=>{node.scrollIntoView({block:'start',behavior:'auto'});if(focus)node.querySelector('summary')?.focus({preventScroll:true})},150))}
function update(v){
  if(!v)return;
  const container=document.querySelector('[data-ll-atelier-request]');
  if(!container)return;
  const id=container.querySelector('[data-ll-atelier-variant-id]');
  const title=container.querySelector('[data-ll-atelier-variant-title]');
  if(id)id.value=v.id||'';
  if(title)title.value=v.title||'';
  // Update the auto-filled variant in contact[body]; preserve customer edits.
  const message=container.querySelector('[data-ll-atelier-message]');
  if(message&&v.title){
    const previous=message.dataset.llAtelierPrefill||'';
    const prefix=(container.dataset.llAtelierLang==='en'?'Piece: ':'Pieza: ')+
      (container.dataset.productTitle||'')+' · '+String(v.title)+'. ';
    if(previous&&message.value.startsWith(previous)){
      message.value=prefix+message.value.slice(previous.length);
    }
    message.dataset.llAtelierPrefill=prefix;
  }
}
document.addEventListener('click',e=>{const a=e.target.closest?.('a[href*="#ll-atelier-"]');if(!a)return;const url=new URL(a.href,location.href);if(url.origin!==location.origin||url.pathname!==location.pathname||!panel()||url.hash!=='#'+panel().id)return;e.preventDefault();history.replaceState(history.state,'',url.pathname+url.search+url.hash);open(true)});
document.addEventListener('variant:change',e=>{if(e.target.closest?.('.shopify-section--main-product'))update(e.detail?.variant)});
function initialize(){if(!panel())return;if(location.hash==='#'+panel().id||document.querySelector('[data-ll-atelier-request] :is(.ll-atelier__success,.ll-atelier__errors)'))open(false)}
document.addEventListener('shopify:section:load',initialize);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
